<template>
  <div>
    <v-card class="mb-4">
      <div v-if="singleClient">
        <v-toolbar
          light
          color="white"
          class="elevation-2"
        >
          <v-toolbar-title>
            <a href=""
              class="no-decoration grey--text text--darken-1"
               @click.prevent="$router.go(-1)">Klienci</a>
            <v-icon color="grey" class="mx-2">chevron_right</v-icon>
            {{singleClient.name}}
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-tooltip left>
            <v-btn
              icon
              slot="activator"
              @click.prevent="editClient"
            >
              <v-icon color="primary">edit</v-icon>
            </v-btn>
            <span>Edytuj klienta</span>
          </v-tooltip>

        </v-toolbar>
        <ClientInfo v-if="singleClient" :singleClient="singleClient" />
      </div>
      <div class="users_loader" v-if="!singleClient">
        <div class="py-4 text-xs-center">
          <v-progress-circular
            :size="30"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </div>
    </v-card>
    <Subscriptions />
    <ClientEditDialog />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ClientInfo from './ClientInfo.vue';
import ClientEditDialog from './../Clients/Dialogs/ClientEditDialog.vue';
import Subscriptions from './../Subscriptions/Subscriptions.vue';

export default {
  name: 'client-single',
  components: {
    ClientInfo,
    ClientEditDialog,
    Subscriptions,
  },
  props: ['clientId'],
  computed: {
    ...mapGetters('clients', [
      'singleClient',
    ]),
  },
  methods: {
    ...mapActions('clients', [
      'setDialogVisbility',
    ]),
    editClient() {
      this.setDialogVisbility({ type: 'edit', id: this.clientId });
    },
  },
};
</script>
